export default __webpack_public_path__ + "static/media/youtube.8815955b.jpg";